// @ts-nocheck

import { SpineAnimationIds } from '../../../../types/animations';

import json from './superman.json';
import image from './superman.png';

import atlas from '!!raw-loader!./superman.atlas';

export default {
  id: SpineAnimationIds.WM_SUPERMAN,
  atlas,
  images: {
    'superman.png': image,
  },
  json,
};
